export default "__VITE_ASSET__b09fad0b__"